export const MobileWidth = 420;

export const ULTRA_MENU = "ULTRA";
export const SOS_MENU = "SOS";
export const CAMPUS_MENU = "CAMPUS";
export const ONESTOP_MENU = "ONE";
export const CR_MENU = "COSTA";
